import { useEffect, useState } from "react";
import useTokenValidation from "../hook/useTokenValidation";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateUser } from "../features/user/userSlice";
import { logoutUser } from "../features/cred/credSlice";
import { LogoutModal } from "../utils";

const ViewProfileLayer = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  const [showLogoutModal, setShowLogoutModal] = useState(false);


  // const { id } = useSelector((state) => state?.cred?.user?.user);
  // const { user } = useSelector((state) => state?.cred?.user);
  const dispatch = useDispatch();
  const { validateAndHandleToken } = useTokenValidation();

  useEffect(() => {
    const fetchUserData = async () => {
      const userInfo = await validateAndHandleToken();
      console.log("User data fetched:", userInfo);
      // console.log("User data?._id fetched:", userInfo?._id);
      setUsername(userInfo?.username);
      setUserInfo(userInfo);
    };
    fetchUserData();
  }, [validateAndHandleToken]);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    const infoToUpdate = {
      username,
      password,
    };

    const result = await dispatch(updateUser({ id: userInfo?._id, updatedData: infoToUpdate }));

    if (!result?.payload?.success) {
      toast.error("Profile did not update successfully!");
      return;
    }

    toast.success("Profile updated successfully.");
    setPassword("");
    setConfirmPassword("");
  

    setTimeout(() => {
      // toast.warning("You need to login again!");
      // dispatch(logoutUser());
      setShowLogoutModal(true);
    }, 2000);
  };

  const isPasswordMatch = confirmPassword.length > 0 && password === confirmPassword;
  const isPasswordMismatch = confirmPassword.length > 0 && password !== confirmPassword;

  return (
    <div className="row gy-4">
      <div className="col-lg-8">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                {/* Name Field */}
                <div className="mb-20">
                  <label
                    htmlFor="user-name"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                  >
                    Full Name <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control radius-8"
                    id="user-name"
                    placeholder="Enter Full Name*"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>

                {/* New Password Field */}
                <div className="mb-20">
                  <label
                    htmlFor="your-password"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                  >
                    New Password <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className="form-control radius-8"
                    id="your-password"
                    placeholder="Enter New Password*"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onDoubleClick={togglePasswordVisibility}
                  />
                </div>

                {/* Confirm Password Field */}
                <div className="mb-20">
                  <label
                    htmlFor="confirm-password"
                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                  >
                    Confirm Password <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type={confirmPasswordVisible ? "text" : "password"}
                    className={`form-control radius-8 ${
                      isPasswordMismatch ? "border-danger-600" : ""
                    }`}
                    id="confirm-password"
                    placeholder="Confirm Password*"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    onDoubleClick={toggleConfirmPasswordVisibility}
                  />
                  {isPasswordMatch && (
                    <div className="text-success text-xs mt-1">✅ Passwords matched.</div>
                  )}
                  {isPasswordMismatch && (
                    <div className="text-danger-600 text-xs mt-1">❌ Passwords do not match.</div>
                  )}
                </div>

                <p className="text-xs text-neutral-500">
                  🔒 Double-click the password fields to toggle visibility
                </p>

                {/* Submit Button */}
                <button className="btn btn-bg mt-20 btn-block" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
      </div>
        <LogoutModal
          show={showLogoutModal}
          onConfirm={() => dispatch(logoutUser())}
        />
    </div>
  );
};

export default ViewProfileLayer